import marketTestPlanReducer from "./marketTestPlanReducer";
import marketTestReducer from "./marketTestReducer";

const marketTestReducers = {
    marketTestPlan : marketTestPlanReducer,
    marketTest : marketTestReducer,
}

export default marketTestReducers;